var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransportLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.535,
    height: 73.723,
    viewBox: "0 0 59.535 73.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26792",
    "data-name": "Group 26792",
    transform: "translate(-10553.854 -1938.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26791",
    "data-name": "Group 26791",
    transform: "translate(-1262.482 -667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26790",
    "data-name": "Group 26790",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26789",
    "data-name": "Group 26789",
    transform: "translate(11816.987 2628.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37911",
    "data-name": "Path 37911",
    d: "M57.65,85.172c.581.818-.28,1.377-.516.495A.852.852,0,0,0,56.381,85",
    transform: "translate(-7.051 -76.847)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37912",
    "data-name": "Path 37912",
    d: "M65.228,51.5l13.3,6.626a.246.246,0,0,1,.129.28l-.065.28a.25.25,0,0,1-.344.172L64.475,52.683",
    transform: "translate(-29.602 -50.553)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1261",
    "data-name": "Ellipse 1261",
    cx: 2.366,
    cy: 3.937,
    rx: 2.366,
    ry: 3.937,
    transform: "translate(23.944 25.407)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37913",
    "data-name": "Path 37913",
    d: "M221.3,184.2c.538,1.527,1.377,2.259,2.409,2.259a2.831,2.831,0,0,0,2.323-1.807",
    transform: "translate(-210.716 -154.706)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.936,
    cy: 3.227,
    rx: 1.936,
    ry: 3.227,
    transform: "translate(48.641 24.804)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37914",
    "data-name": "Path 37914",
    d: "M201.35,92.254l-15.081-.409,2.151-6.389,14.693-1.162a.351.351,0,0,1,.366.43Z",
    transform: "translate(-180.633 -76.292)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37915",
    "data-name": "Path 37915",
    d: "M174.2,98.043,173.034,98a.425.425,0,0,0-.387.473L172,102.819c-.022.323.215.559.452.495l1.85-.473a.483.483,0,0,0,.323-.495l-.043-3.851A.446.446,0,0,0,174.2,98.043Z",
    transform: "translate(-148.703 -87.05)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.398,
    cy: 1.398,
    rx: 1.398,
    ry: 1.398,
    transform: "translate(32.829 0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3849",
    "data-name": "Line 3849",
    y1: 1.011,
    x2: 9.079,
    transform: "translate(14.865 28.999)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3850",
    "data-name": "Line 3850",
    x1: 5.421,
    y1: 0.602,
    transform: "translate(3.894 26.375)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 0.581,
    cy: 1.527,
    rx: 0.581,
    ry: 1.527,
    transform: "translate(49.996 26.504)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 0.731,
    cy: 1.915,
    rx: 0.731,
    ry: 1.915,
    transform: "translate(25.6 27.429)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37916",
    "data-name": "Path 37916",
    d: "M28.363,90.173H54.114a.67.67,0,0,1,.667.667v5.378L28.1,97.616,28.083,78.9l-4.883.022",
    transform: "translate(3.153 -72.059)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3851",
    "data-name": "Line 3851",
    x1: 1.807,
    y1: 0.237,
    transform: "translate(22.202 11.23)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3852",
    "data-name": "Line 3852",
    x1: 2.216,
    y1: 0.258,
    transform: "translate(20.932 15.253)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3853",
    "data-name": "Line 3853",
    y2: 16.199,
    transform: "translate(35.195 2.28)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3854",
    "data-name": "Line 3854",
    y2: 16.199,
    transform: "translate(33.281 2.28)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37917",
    "data-name": "Path 37917",
    d: "M121.678,85.483l-1.484,3.872L120,88.065l1.076-2.818a.329.329,0,0,1,.409-.194h0A.351.351,0,0,1,121.678,85.483Z",
    transform: "translate(-84.59 -76.878)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3855",
    "data-name": "Line 3855",
    y1: 4.604,
    x2: 1.807,
    transform: "translate(36.873 3.657)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37918",
    "data-name": "Path 37918",
    d: "M211.191,150.5H207.9l1.312-2.539h1.979l2.84-1.463.947,2.345Z",
    transform: "translate(-196.778 -125.116)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37919",
    "data-name": "Path 37919",
    d: "M279.6,147.7l1.527.495,1.119,2.711-2.625-.667",
    transform: "translate(-279.471 -126.058)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37920",
    "data-name": "Path 37920",
    d: "M182.2,97.965l1.2-.151-.688-19a2.066,2.066,0,0,0-1.678-1.958L176.648,76l-14.091,1.248c-.559.065-.861.495-1.054,1.14l-2.366,6.927-2.366,1.441a7.361,7.361,0,0,0-3.27,5.679V95.6c0,2.28,1.119,2.625,2.56,2.732l12.456,1.441",
    transform: "translate(-153.5 -69.783)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3856",
    "data-name": "Line 3856",
    x1: 1.097,
    y1: 0.043,
    transform: "translate(29.709 25.557)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mina_produkter",
    "data-name": "Mina produkter",
    transform: "translate(-1492.697 638.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26735",
    "data-name": "Group 26735",
    transform: "translate(13321.348 1969.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26658",
    "data-name": "Group 26658",
    transform: "translate(9.164 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M0,16.27V-6.559a4.515,4.515,0,0,1,4.513-4.515H32.595a4.513,4.513,0,0,1,4.513,4.515v62.8a4.513,4.513,0,0,1-4.513,4.513H4.513A4.514,4.514,0,0,1,0,56.236V39.8",
    transform: "translate(0 11.074)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26659",
    "data-name": "Group 26659",
    transform: "translate(19.103 66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M0,0H17.229",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660",
    transform: "translate(22.522 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37305",
    "data-name": "Path 37305",
    d: "M0,0H6.957",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661",
    transform: "translate(32.773 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37306",
    "data-name": "Path 37306",
    d: "M0,0H.14",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransportLibrary);
export default __webpack_public_path__ + "static/media/Icon_transportLibrary.b27edc6f45c4b93e7b59348534bd55a0.svg";
export { ForwardRef as ReactComponent };